import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    // 监管模式设置默认值
    if (!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    let columns = [
      {
        title: '订单号',
        key: 'orderNo',
        align: 'center',
        width: 230,
        ellipsis: true,
        tooltip: true
      },

      {
        title: '所属团队',
        key: 'groupName',
        align: 'center',
        minWidth: 200,
        render(h, params) {
          const res = params.row.groupName ? params.row.orgName + '/' + params.row.groupName : params.row.orgName;
          return (
            <Tooltip style="width:100%" content={res}>
              <div class="txt-ellipsis2" style="display:block">
                {res}
              </div>
            </Tooltip>
          );
        }
      },
      {
        title: '所属业务员',
        key: 'salesmanName',
        align: 'center',
        minWidth: 160
      },
      {
        title: '业务类别',
        key: 'sellType',
        align: 'center',
        slot: 'sellTypeSlot',
        width: 100
      },
      {
        title: '产品名称',
        minWidth: 200,
        key: 'productName',
        align: 'center',
        render(h, params) {
          return (
            <span>
              {params.row.productName}({params.row.productCode})
            </span>
          );
        }
      }
    ];
    if (this.$units.showSupplier() && this.$units.pointAction('order_10_7')) {
      columns.push({
        title: '供应商',
        key: 'supplierName',
        align: 'center',
        minWidth: 100
      });
    }
    columns = columns.concat([
      {
        title: '投/被保险人',
        key: 'holderName',
        align: 'center',
        minWidth: 160,
        tooltip: true,
        render(h, params) {
          if (params.row.insuranceName) {
            const res = params.row.holderName + '/' + params.row.insuranceName;
            return <span>{res}</span>;
          } else {
            const res = params.row.holderName;
            return <span>{res}</span>;
          }
        }
      },
      {
        title: '保费（元）',
        key: 'fee',
        align: 'center',
        minWidth: 120,
        tooltip: true
      },
      {
        title: '公司标保（元）',
        key: 'foldFyb',
        align: 'center',
        minWidth: 120,
        tooltip: true
      },
      {
        title: '订单状态',
        key: 'status',
        align: 'center',
        minWidth: 120,
        tooltip: true,
        render(h, params) {
          let value = '';
          const payStatus = params.row.status;
          const checkStaus = params.row.checkInsuranceStatus;
          const result = filter.filterOrderStatus(payStatus);
          // 1 核保成功 2 人工核保中 3 核保失败 4 已撤单
          if (payStatus != 1) {
            value = result;
          } else {
            // const arr = ["待核保","核保成功", "人工核保中", "核保失败", "已撤单"];
            let typeName = '';
            if (checkStaus == '0') {
              typeName = '待核保';
            } else if (checkStaus == '1') {
              typeName = '核保成功';
            } else if (checkStaus == '2') {
              typeName = '人工核保中';
            } else if (checkStaus == '3') {
              typeName = '核保失败';
            } else if (checkStaus == '4') {
              typeName = '已撤单';
            } else if (checkStaus == '10') {
              typeName = '预核保成功';
            } else if (checkStaus == '-3') {
              typeName = '预核保失败';
            }
            if (checkStaus == 1) {
              value = '未支付';
            } else {
              const other = typeName;
              value = result + '-' + other;
            }
          }
          return <span>{value}</span>;
        }
      },
      {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        minWidth: 160,
        tooltip: true,
        render(h, params) {
          const time = filter.filterTime(params.row.createTime, 'YYYY-MM-DD HH:mm');
          return <span>{time}</span>;
        }
      }
    ]);

    if (this.$units.isOkTX() || this.$units.isOkBao()|| this.$units.isRYBB()) {
      columns = columns.concat([
        {
          title: '推广执行人',
          slot: 'executer',
          align: 'center',
          minWidth: 100
        },
        {
          title: '推广渠道 ',
          slot: 'channel',
          align: 'center',
          minWidth: 100
        }
      ]);
    }
    columns = columns.concat([
      {
        title: '操作',
        slot: 'bar',
        align: 'center',
        width: 200,
        fixed: 'right'
      }
    ]);
    console.log(columns);
    this.columns = columns;
  },
  methods: {}
};
